export default {
    apiUrl: 'solo.minemine.online/api' || import.meta.env.VITE_API_URL,
    apiProtocol: 'https' || import.meta.env.VITE_API_PROTOCOL || 'http'
};
